"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var types = exports.types = {
    MARKER_LAYOUT: 1
};